import {FC, MouseEvent} from 'react';

type ErrorComponentPropsT = {
  error?: Error;
  errorInfo?: React.ErrorInfo;
  onRetry?: (event: MouseEvent<HTMLButtonElement>) => void;
};

const ErrorComponent: FC<ErrorComponentPropsT> = ({onRetry, error, errorInfo}) => {
  const handleBackToHome = () => {
    window.location.href = '/';
  };

  // Format the component stack for better readability
  const formatComponentStack = (stack?: string) => {
    if (!stack) return 'No additional error information available';
    return stack
      .split('\n')
      .slice(1) // Remove the first line which is usually just "in ComponentName"
      .map(line => line.trim())
      .join('\n');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-light/50 dark:bg-bodybg">
      <div className="container">
        <div className="flex flex-col items-center justify-center px-4 py-10">
          <div className="mb-5 text-center">
            <h1 className="mb-2 text-8xl font-bold text-primary">Oops!</h1>
            <div className="mb-5 text-2xl font-semibold text-gray-800 dark:text-white">
              {error?.message || 'An unexpected error occurred'} 😭
            </div>
            <p className="text-gray-500 dark:text-gray-400">
              Something went wrong. Don&apos;t worry, we can fix this together.
            </p>
          </div>

          {errorInfo?.componentStack && (
            <div className="mb-8 w-full max-w-2xl">
              <div className="overflow-hidden rounded-lg border border-gray-200 bg-white/50 shadow-sm backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800/50">
                <div className="border-b border-gray-200 bg-gray-50/50 px-4 py-3 dark:border-gray-700 dark:bg-gray-800/30">
                  <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">Error Details</h3>
                </div>
                <div className="p-4">
                  <pre className="font-mono whitespace-pre-wrap text-xs text-gray-600 dark:text-gray-400">
                    {formatComponentStack(errorInfo.componentStack)}
                  </pre>
                </div>
              </div>
            </div>
          )}

          <div className="flex items-center gap-3">
            <button
              onClick={handleBackToHome}
              className="ti-btn bg-primary px-6 py-2 font-semibold text-white transition hover:bg-primary/90"
            >
              <i className="ri-home-line me-2 inline-block align-middle text-lg"></i>
              Back to Home
            </button>
            <button
              onClick={onRetry}
              className="ti-btn bg-success px-6 py-2 font-semibold text-white transition hover:bg-success/90"
            >
              <i className="ri-refresh-line me-2 inline-block align-middle text-lg"></i>
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
